import script from "./back-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./back-button.vue?vue&type=script&lang=ts&setup=true"

import "./back-button.vue?vue&type=style&index=0&id=652c77ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652c77ba"]])

export default __exports__